export const STATUS_TABS = [
  { value: "all", label: "All" },
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
];

export const formatDateToIST = (dateString) => {
  if (!dateString) return "—";
  try {
    const dateObj = new Date(dateString);
    if (isNaN(dateObj.getTime())) return "—";
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("en-GB", { month: "short", timeZone: "Asia/Kolkata" });
    const year = dateObj.getFullYear();
    let hours = dateObj.getHours();
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${day} ${month} ${year}, ${hours.toString().padStart(2, "0")}:${minutes} ${ampm}`;
  } catch {
    return "—";
  }
};

export const formatCurrency = (value) => {
  const num = Number(value);
  if (Number.isNaN(num)) return "—";
  return `₹${num.toLocaleString("en-IN")}`;
};

export const toApiDate = (value) => {
  if (!value) return "";
  if (value instanceof Date) return value.toISOString().split("T")[0];
  if (typeof value === "string") return value.split("T")[0];
  return "";
};

export const getDefaultDateRange = () => {
  const today = new Date();
  const from = new Date(today.getFullYear(), today.getMonth(), 1);
  return {
    fromDate: from.toISOString().split("T")[0],
    toDate: today.toISOString().split("T")[0],
  };
};

export function extractPaymentsFromResponse(response) {
  if (!response || typeof response !== "object") return [];
  if (Array.isArray(response)) return response;
  if (Array.isArray(response.results)) return response.results;
  if (Array.isArray(response.data)) return response.data;

  const dataObj = response.data;
  if (dataObj && typeof dataObj === "object" && !Array.isArray(dataObj)) {
    const keys = [
      "pending_payments",
      "payments",
      "transactions",
      "results",
      "data",
      "advance_payments",
    ];
    for (const key of keys) {
      if (Array.isArray(dataObj[key])) return dataObj[key];
    }
    const firstArray = Object.values(dataObj).find((value) => Array.isArray(value));
    if (firstArray) return firstArray;
  }
  return [];
}

export function extractPaginationFromResponse(response) {
  if (!response || typeof response !== "object") return null;
  return (
    response.pagination ||
    response.meta ||
    (response.data &&
      typeof response.data === "object" &&
      !Array.isArray(response.data) &&
      response.data.pagination) ||
    null
  );
}

export const normalizePaymentRow = (row = {}) => {
  const order = row.order || row.order_details || {};
  const method = row.method || row.payment_method || {};
  const fields = row.fields || {};

  return {
    id: row.id ?? row.advance_payment_id ?? row.pk,
    order_id: row.order_id ?? order.id ?? order.order_id,
    order_number: order.order_number ?? order.order_id ?? row.order_number,
    farmer_name:
      order.farmer_name ??
      order.customer_name ??
      row.farmer_name ??
      row.customer_name ??
      "—",
    company_name: order.company?.name ?? row.company_name ?? "—",
    advance_amount: row.advance_amount ?? row.amount ?? fields.cheque_amount,
    transaction_id:
      row.transaction_id ?? fields.transaction_id ?? fields.transaction_reference_no,
    transaction_reference_no:
      fields.transaction_reference_no ?? row.transaction_reference_no ?? row.transaction_id,
    payment_method: method.name ?? row.payment_method_name ?? row.payment_method ?? "—",
    status:
      row.status ??
      row.transaction_status ??
      row.payment_status?.name ??
      row.payment_status ??
      "pending",
    created_at: row.created_at ?? row.payment_date ?? row.date,
    method,
    fields,
    order,
    raw: row,
  };
};
